// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__7+ikJ","vertical":"Menu_vertical__sMZmf"};